import { createSvgIcon } from '@mui/material';

const icon = (
  <>
    <path d='M18 2H10L4 8V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM18 4V20H6V8.83L10.83 4H18Z' />
    <path d='M12 18L16 14H13.6V10H10.4V14H8L12 18Z' />
  </>
);

export const DownloadDocumentIcon = createSvgIcon(icon, 'DownloadDocumentIcon');
